import React, { useState } from "react";
import { FaExpand, FaCompress, FaCopy, FaTerminal } from "react-icons/fa";

export default function ScreenCodeBlock({
  code,
  language = "js",
  collapsedHeight = 240,
  filename = "",
}) {
  const [fullscreen, setFullscreen] = useState(false);


// Logik Min Höhe wenn nun eine Code zeile da ist Max wenn mehr da sind 


const codeLines = code ? code.split("\n").length : 0;
const lineHeight = 1.5; // in em, kannst du anpassen je nach Design
let minHeight;

if (codeLines <= 1) {
  minHeight = `${1* lineHeight}em`; // Mindestens 3 Zeilen
} else if (codeLines < 5) {
  minHeight = `${codeLines * lineHeight}em`;
} else {
  minHeight = `${5 * lineHeight}em`; // Maximal 5 Zeilen für den Start
}



  const handleCopy = () => navigator.clipboard.writeText(code);

  // Ein bisschen Flair: Dateiname oder Sprache im Balken oben
  const headerText = filename
    ? filename
    : language
    ? `.${language}`
    : "Code";

  return (
    <>
      {/* Normale (gekürzte) Ansicht */}
      <div className="relative rounded-lg overflow-hidden border bg-gray-900 border-gray-700 shadow-lg mb-4">
        <pre
          className="text-xs leading-relaxed text-brand px-4 py-3 font-mono"
          style={{
            maxHeight: fullscreen ? "none" : `${collapsedHeight}px`,
            minHeight: fullscreen ? undefined : minHeight, // nur normalmodus 
            overflow: "auto",
          }}
        >
          <code>{code}</code>
        </pre>

        {/* Mask-Overlay */}
        {!fullscreen && (
          <div
            className="pointer-events-none absolute left-0 right-0 bottom-0 h-14 border-3 border-gray-900 bg-gray-950"
            style={{
             
            }}
          />
        )}

        {/* Button-Leiste */}
        <div className="absolute right-2 bottom-2 flex gap-2 z-10">
          <button
            title="Code kopieren"
            onClick={handleCopy}
            className="p-1 bg-black/60 rounded text-brand hover:bg-brand hover:text-black transition"
          >
            <FaCopy size={16} />
          </button>
          <button
            title="Vollbild"
            onClick={() => setFullscreen(true)}
            className="p-1 bg-black/60 rounded text-brand hover:bg-brand hover:text-black transition"
          >
            <FaExpand size={16} />
          </button>
        </div>
      </div>

      {/* ScreenFrame Overlay */}
      {fullscreen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50/75 backdrop-blur-lg">
          <div className="relative w-full max-w-3xl rounded-2xl shadow-2xl border-2 border-brand bg-gray-950 flex flex-col overflow-hidden animate-fade-in">
            {/* Frame-Balken oben */}
            <div className="flex items-center justify-between bg-gradient-to-br from-gray-50 via-gray-100 to-gray-50 px-5 py-3 border-b border-black">
              <div className="flex items-center gap-2 font-mono text-xs text-black font-semibold">
                <FaTerminal className="opacity-60" />
                <span>
                  {headerText}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <button
                  title="Code kopieren"
                  onClick={handleCopy}
                  className="p-1 rounded text-gray-800 hover:text-gray-700"
                >
                  <FaCopy size={14} />
                </button>
                <button
                  title="Schließen"
                  onClick={() => setFullscreen(false)}
                  className="p-1 rounded text-gray-800 hover:text-gray-500"
                >
                  <FaCompress size={16} />
                </button>
              </div>
            </div>
            {/* Code-Bereich */}
            <pre className="
            text-sm 
            leading-relaxed 
            text-brand 
            px-4 py-3 p-6 font-mono 
            overflow-auto 
            max-h-[70vh] 
            bg-gray-950
            z-999">
              <code>{code}</code>
            </pre>
          </div>
        </div>
      )}
    </>
  );
}
